<template>
  <section id="oferta" class="section-shell offer-section" data-theme="climax">
    <div class="offer-copy" data-reveal>
      <p class="eyebrow">Escolha Como Entrar</p>
      <h2 class="offer-title">Voc&ecirc; sabe que pode mais.</h2>

      <div class="offer-manifesto">
        <p>Voc&ecirc; sabe que o jogo tem regras &mdash; e voc&ecirc; n&atilde;o as conhece.</p>
        <p>A diferen&ccedil;a entre quem ganha e quem perde n&atilde;o &eacute; sorte.</p>
      </div>

      <ul class="offer-rhythm" aria-label="Pilares da proposta ZIMA">
        <li>&Eacute; leitura.</li>
        <li>&Eacute; timing.</li>
        <li>&Eacute; clareza.</li>
        <li>&Eacute; estar do lado certo do mercado &mdash; enquanto os outros reagem.</li>
      </ul>

      <div class="offer-close">
        <p>A <span class="word-brand">ZIMA</span> te entrega isso.</p>
      </div>
    </div>

    <div class="offer-header" data-reveal>
      <h3>Escolha como voc&ecirc; quer entrar.</h3>
      <p>Todos os planos incluem acesso completo.</p>
    </div>

    <div class="plans-grid" data-reveal>
      <article
        v-for="plan in plans"
        :key="plan.key"
        class="plan-card"
        :class="{ featured: plan.featured }"
      >
        <div class="plan-top">
          <p class="plan-kicker">
            {{ plan.name }}
            <span v-if="plan.featured" class="featured-chip">&#9733; MAIS ESCOLHIDO</span>
          </p>
          <p class="plan-hook">{{ plan.hook }}</p>
        </div>

        <ul class="plan-points">
          <li v-for="point in plan.points" :key="point" v-html="point"></li>
        </ul>

        <div class="plan-price">
          <p class="price-main">{{ plan.price }}</p>
          <p class="price-sub" v-html="plan.monthly"></p>
        </div>

        <div class="plan-payment-notes">
          <p v-for="note in plan.paymentNotes" :key="note" v-html="note"></p>
        </div>

        <button class="cta primary cta-offer" @click="emit('cta', plan.key)" v-html="plan.cta"></button>
      </article>
    </div>
  </section>
</template>

<script setup>
import { getCurrentInstance } from 'vue';

const instance = getCurrentInstance();
const emit = instance ? instance.emit : () => {};

const plans = [
  {
    key: 'mensal',
    name: 'MENSAL',
    hook: 'Entrada imediata, sem travar compromisso.',
    points: [
      '1 m&ecirc;s de acesso completo ao sistema <span class="word-brand">ZIMA</span>.',
      'Come&ccedil;a por R$ 97 e testa a leitura na pr&aacute;tica.',
      'Ideal pra entrar agora e sentir o ritmo da opera&ccedil;&atilde;o.',
    ],
    price: 'R$ 97',
    monthly: '(R$ 97,00/m&ecirc;s)',
    paymentNotes: [
      'PIX: <strong>R$ 92,15</strong>',
      'Cart&atilde;o e boleto: <strong>R$ 97,00</strong>',
    ],
    cta: '[Quero entrar no mensal &#129416;]',
    featured: false,
  },
  {
    key: 'trimestral',
    name: 'TRIMESTRAL',
    hook: 'Experimente sem compromisso longo.',
    points: [
      '3 meses de acesso completo ao sistema <span class="word-brand">ZIMA</span>.',
      'An&aacute;lises e mapa di&aacute;rio desde o primeiro dia.',
      'Mapa di&aacute;rio, leitura institucional, execu&ccedil;&atilde;o com clareza.',
    ],
    price: 'R$ 247',
    monthly: '(R$ 82,33/m&ecirc;s)',
    paymentNotes: [
      'PIX: <strong>R$ 234,65</strong>',
      'Cart&atilde;o e boleto: <strong>R$ 247,00</strong>',
    ],
    cta: '[Quero entrar no trimestral &#129416;]',
    featured: false,
  },
  {
    key: 'semestral',
    name: 'SEMESTRAL',
    hook: 'O tempo certo pra virar o jogo.',
    points: [
      '6 meses pra desenvolver leitura real de mercado.',
      'Tempo suficiente pra sair do modo reativo e entrar no modo estrat&eacute;gico.',
      'Sai por R$ 74,50/m&ecirc;s no valor normal, R$ 62,08/m&ecirc;s no cart&atilde;o &agrave; vista e R$ 58,98/m&ecirc;s no PIX.',
    ],
    price: 'R$ 447',
    monthly: '(R$ 74,50/m&ecirc;s)',
    paymentNotes: [
      'Cart&atilde;o &agrave; vista: <strong>R$ 372,50</strong>',
      'PIX: <strong>R$ 353,88</strong>',
      'Parcelado e boleto: <strong>R$ 447,00</strong>',
    ],
    cta: '[Quero entrar no semestral &#129416;]',
    featured: true,
  },
  {
    key: 'anual',
    name: 'ANUAL',
    hook: 'Pra quem decidiu de vez.',
    points: [
      '12 meses de imers&atilde;o completa no sistema <span class="word-brand">ZIMA</span>.',
      'Sai por R$ 66,42/m&ecirc;s no valor normal, R$ 55,35/m&ecirc;s no cart&atilde;o &agrave; vista e R$ 52,57/m&ecirc;s no PIX.',
      'O mercado recompensa quem tem vis&atilde;o de longo prazo &mdash; e voc&ecirc; tamb&eacute;m.',
    ],
    price: 'R$ 797',
    monthly: '(R$ 66,42/m&ecirc;s)',
    paymentNotes: [
      'Cart&atilde;o &agrave; vista: <strong>R$ 664,18</strong>',
      'PIX: <strong>R$ 630,80</strong>',
      'Parcelado e boleto: <strong>R$ 797,00</strong>',
    ],
    cta: '[Quero entrar no anual &#129416;]',
    featured: false,
  },
];
</script>

<style scoped>
.offer-section {
  display: grid;
  gap: 24px;
  border-radius: 24px;
  border: 1px solid rgba(115, 148, 240, 0.18);
  background:
    radial-gradient(circle at 12% 12%, rgba(78, 115, 223, 0.16), transparent 34%),
    radial-gradient(circle at 86% 10%, rgba(155, 89, 182, 0.14), transparent 30%),
    linear-gradient(180deg, rgba(9, 12, 22, 0.96), rgba(7, 9, 16, 0.98));
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.offer-section,
.offer-section * {
  font-family: 'Space Grotesk', 'Manrope', 'Inter', sans-serif !important;
}

.word-brand {
  background: linear-gradient(120deg, #6fa6ff 0%, #bd8bff 45%, #7ea5ff 75%, #d2b2ff 100%);
  background-size: 220% 220%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-shadow: 0 0 14px rgba(127, 166, 255, 0.28);
  animation: zima-brand-shift 4.2s ease-in-out infinite;
  will-change: background-position;
}

.offer-copy {
  display: grid;
  gap: 16px;
  max-width: 820px;
}

.offer-title {
  margin: 0;
  color: #eef3ff;
  font-size: clamp(2.4rem, 5vw, 4.7rem);
  line-height: 0.94;
  letter-spacing: -0.04em;
  text-transform: uppercase;
}

.offer-manifesto,
.offer-close {
  display: grid;
  gap: 6px;
}

.offer-manifesto p,
.offer-close p {
  margin: 0;
  color: #d8e3f8;
  font-size: clamp(1.06rem, 1.5vw, 1.28rem);
  line-height: 1.5;
}

.offer-rhythm {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 10px;
}

.offer-rhythm li {
  position: relative;
  padding: 14px 18px 14px 20px;
  border-radius: 16px;
  border: 1px solid rgba(130, 164, 246, 0.18);
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.02));
  color: #edf3ff;
  font-size: clamp(1.04rem, 1.4vw, 1.24rem);
  line-height: 1.35;
  overflow: hidden;
}

.offer-rhythm li::before {
  content: '';
  position: absolute;
  inset: 0 auto 0 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(132, 173, 255, 0.92), rgba(189, 145, 255, 0.88));
  box-shadow: 0 0 18px rgba(115, 148, 240, 0.38);
}

.offer-header {
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
  padding-top: 6px;
  border-top: 1px solid rgba(144, 170, 240, 0.12);
}

.offer-header h3 {
  margin: 0;
  color: #f3f7ff;
  font-size: clamp(1.4rem, 2vw, 2rem);
  line-height: 1.08;
}

.offer-header p {
  margin: 0;
  color: #acbddb;
  font-size: 0.96rem;
  white-space: nowrap;
}

.plans-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
}

.plan-card {
  position: relative;
  display: grid;
  gap: 18px;
  padding: 20px;
  border-radius: 20px;
  border: 1px solid rgba(129, 158, 240, 0.22);
  background:
    radial-gradient(circle at 100% 0%, rgba(155, 89, 182, 0.08), transparent 36%),
    linear-gradient(160deg, rgba(17, 22, 38, 0.96), rgba(10, 14, 26, 0.94));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.05),
    0 14px 36px rgba(0, 0, 0, 0.24);
}

.plan-card.featured {
  transform: translateY(-6px);
  border-color: rgba(160, 190, 255, 0.44);
  background:
    radial-gradient(circle at 84% 8%, rgba(155, 89, 182, 0.14), transparent 34%),
    radial-gradient(circle at 12% 100%, rgba(78, 115, 223, 0.12), transparent 38%),
    linear-gradient(160deg, rgba(22, 28, 48, 0.98), rgba(12, 17, 31, 0.96));
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.08),
    0 18px 44px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(130, 165, 249, 0.14);
}

.plan-top {
  display: grid;
  gap: 10px;
}

.plan-kicker {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  color: #b6c8ea;
  font-size: 0.82rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.featured-chip {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid rgba(170, 200, 255, 0.34);
  background: linear-gradient(120deg, rgba(78, 115, 223, 0.2), rgba(155, 89, 182, 0.18));
  color: #eef4ff;
  font-size: 0.7rem;
  letter-spacing: 0.08em;
}

.plan-hook {
  margin: 0;
  color: #f2f6ff;
  font-size: clamp(1.35rem, 2vw, 1.8rem);
  line-height: 1.08;
  font-weight: 700;
}

.plan-points {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 10px;
}

.plan-points li {
  position: relative;
  padding-left: 16px;
  color: #d2ddf2;
  line-height: 1.45;
  font-size: 0.98rem;
}

.plan-points li::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0.5em;
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: linear-gradient(120deg, #7ea5ff, #ba91ff);
  box-shadow: 0 0 12px rgba(122, 162, 255, 0.38);
}

.plan-price {
  margin-top: auto;
  padding-top: 4px;
  border-top: 1px solid rgba(144, 170, 240, 0.12);
}

.price-main {
  margin: 0;
  color: #f6fbff;
  font-size: clamp(2rem, 3vw, 2.6rem);
  font-weight: 800;
  line-height: 1;
}

.price-sub {
  margin: 6px 0 0;
  color: #97efc7;
  font-size: 1rem;
  font-weight: 700;
}

.cta-offer {
  width: 100%;
  min-height: 54px;
}

.plan-payment-notes {
  display: grid;
  gap: 6px;
  padding-top: 2px;
}

.plan-payment-notes p {
  margin: 0;
  color: #a8b8d8;
  font-size: 0.88rem;
  line-height: 1.4;
}

@media (max-width: 980px) {
  .plans-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .plan-card.featured {
    transform: none;
  }
}

@media (max-width: 767px) {
  .plans-grid {
    grid-template-columns: 1fr;
  }

  .offer-section {
    gap: 20px;
  }

  .offer-header {
    display: grid;
    align-items: start;
  }

  .offer-header p {
    white-space: normal;
  }

  .plan-card {
    padding: 18px;
  }
}

@keyframes zima-brand-shift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
</style>
